import { AfterViewInit, Component, OnInit, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ServiceService } from '../services/service.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { IdleTimeoutService } from '../idle-timeout.service';
import { Title } from '@angular/platform-browser';
import iziToast from 'izitoast';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements AfterViewInit, OnInit {
  @ViewChild('firstOtpInput') firstOtpInput!: ElementRef;
  loginForm: FormGroup;
  otpForm: FormGroup;
  otpModalVisible: boolean = false;
  message: any = '';
  timerDisplay: string = '';
  showTimer: boolean = true;
  private timerInterval: any;
  currentYear: number = new Date().getFullYear();
  message1: any;
  private overlay: HTMLElement | null = null;
  loginButton: boolean = false;
  constructor(private fb: FormBuilder, private ServerService: ServiceService, private router: Router, private auth: AuthService, private idle: IdleTimeoutService, private titleService: Title, private renderer: Renderer2) {
    this.loginForm = this.fb.group({
      user_name: ['', [
        Validators.required,
        Validators.pattern(/^[6-9]\d{9}$/)
      ]]
    });

    // Clear message on valid input
    this.loginForm.get('user_name')?.valueChanges.subscribe(() => {
      if (this.loginForm.get('user_name')?.valid) {
        this.message = '';
      }
    });

    // this.otpForm = this.fb.group({
    //   otp: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
    // });

    this.otpForm = this.fb.group({
      otp: this.fb.array([])
    });
  }
  ngOnInit(): void {
    this.titleService.setTitle('User Login - Chettinad Link Broadband Services');
    if (this.auth.isLoggedIn() && !this.auth.isSessionExpired()) {
      this.router.navigate(['/users-dashboard']);
    }

  }

  loaderStart() {
    // Create overlay and loader only when API is called
    this.overlay = this.renderer.createElement('div');
    const loader = this.renderer.createElement('div');

    this.renderer.addClass(this.overlay, 'overlay');
    this.renderer.addClass(loader, 'loader');

    loader.innerHTML = 'Loading...'; // Optional text

    this.renderer.appendChild(this.overlay, loader);
    this.renderer.appendChild(document.body, this.overlay);
  }
  loaderEnd() {
    this.renderer.removeChild(document.body, this.overlay);
  }

  ngAfterViewInit(): void {
    $('.slider').slick({
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 800,
      cssEase: 'ease-in-out',
    });
  }
  // Called when user submits mobile number
  onSubmit() {

    var mobile = this.loginForm.value.user_name
    // localStorage.setItem('user_name', mobile);
    // this.auth.login('dummy_token');
    // this.idle.startWatching();
    // this.log_details();
    // this.router.navigate(['/users-dashboard']);
    // return false;
    this.loaderStart();
    if (this.loginForm.valid) {

      const api_req: any = {
        action: "get_customer",
        phone_number: this.loginForm.value.user_name

      };


      this.ServerService.sendzohoServer(api_req).subscribe((response: any) => {
        if (response.data == 1 || response.data == "1") {


          const mobile = this.loginForm.value.user_name;
          const otp = this.ServerService.generateOtp(mobile); // Generate and store OTP internally


          // const otpArray = this.fb.array([]);
          // for (let i = 0; i < otp.length; i++) {
          //   otpArray.push(this.fb.control(''));
          // }
          // this.otpForm.setControl('otp', otpArray);
          // this.loginButton = true;
          // this.otpModalVisible = true;
          // setTimeout(() => {
          //   this.firstOtpInput?.nativeElement.focus();
          // }, 0);
          // this.loaderEnd();
          // return false;

          // Send OTP via SMS API
          this.ServerService.sendOtpSms(mobile, otp).subscribe({
            next: () => {
              const otpArray = this.fb.array([]);
              for (let i = 0; i < otp.length; i++) {
                otpArray.push(this.fb.control(''));
              }
              this.otpForm.setControl('otp', otpArray);
              this.loginButton = true;
              this.otpModalVisible = true;
              setTimeout(() => {
                this.firstOtpInput?.nativeElement.focus();
              }, 0);

              // Optional: auto-fill OTP in dev mode

              // setTimeout(() => {
              //   const controls = this.otpForm.get('otp')?.['controls'];
              //   for (let i = 0; i < otp.length; i++) {
              //     controls[i].setValue(otp[i]);
              //   }
              // }, 2000);
              this.loaderEnd();
              this.startResendTimer();
            },
            error: () => {
              this.message = 'Failed to send OTP. Please try again.';
              this.loaderEnd();
            }
          });


        } else {

          iziToast.error({
            message: 'Enter a Register mobile number!',
            position: 'topRight'
          });
          this.loaderEnd();

        }
      });


    } else {
      this.message = 'Enter a valid 10-digit mobile number!';
      this.loaderEnd();
    }



  }
  startResendTimer() {
    let timeLeft = 120; // 2 minutes in seconds
    this.showTimer = true;

    this.updateTimerDisplay(timeLeft);

    this.timerInterval = setInterval(() => {
      timeLeft--;
      this.updateTimerDisplay(timeLeft);

      if (timeLeft <= 0) {
        clearInterval(this.timerInterval);
        this.showTimer = false;
      }
    }, 1000);
  }

  updateTimerDisplay(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    this.timerDisplay = `${this.padZero(minutes)}:${this.padZero(secs)}`;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : '' + num;
  }

  resendOTP() {
    // Trigger your resend OTP logic here
    const mobile = this.loginForm.value.user_name;
    const otp = this.ServerService.generateOtp(mobile); // Generate and store OTP internally
    // Send OTP via SMS API

    this.ServerService.sendOtpSms(mobile, otp).subscribe({
      next: () => {
        const otpArray = this.fb.array([]);
        for (let i = 0; i < otp.length; i++) {
          otpArray.push(this.fb.control(''));
        }
        this.otpForm.setControl('otp', otpArray);
        this.otpModalVisible = true;

        // Optional: auto-fill OTP in dev mode

        // setTimeout(() => {
        //   const controls = this.otpForm.get('otp')?.['controls'];
        //   for (let i = 0; i < otp.length; i++) {
        //     controls[i].setValue(otp[i]);
        //   }
        // }, 2000);
        this.loaderEnd();
        this.startResendTimer();
      },
      error: () => {
        this.message = 'Failed to send OTP. Please try again.';
        this.loaderEnd();
      }
    });
  }
  // Handle typing and backspace navigation in OTP fields
  onOtpKeyUp(event: any, index: number) {
    const input = event.target;
    const value = input.value;
    const inputs = document.querySelectorAll('.otp-input');

    const controls = this.otpForm.get('otp')?.['controls'];

    if (event.key === 'Backspace') {
      if (value.length !== 0) {
        input.value = '';
        controls[index].setValue('');
      } else if (index > 0) {
        const prevInput = inputs[index - 1] as HTMLInputElement;
        prevInput.focus();
        prevInput.value = '';
        controls[index - 1].setValue('');
      }
    } else {
      if (value.length === 1 && index < inputs.length - 1) {
        const nextInput = inputs[index + 1] as HTMLInputElement;
        nextInput.focus();
      }
    }
    const hasEmptyField = controls.some((control: FormControl) => !control.value || control.value.trim() === '');
    if (!hasEmptyField) {
      this.message = '';
    }
  }


  otpHasEmptyField(): boolean {
    const otpControls = this.otpForm.get('otp')['controls'];
    return otpControls.some((control: FormControl) => !control.value || control.value.trim() === '');
  }

  // Verify OTP when user submits it
  verifyOTP() {
    this.loaderStart();
    const mobile = this.loginForm.value.user_name;
    const controls = this.otpForm.get('otp')?.['controls'];
    const enteredOtp = controls.map(control => control.value).join('');

    // Check if any OTP input is empty
    const hasEmptyField = controls.some(control => !control.value || control.value.trim() === '');

    if (hasEmptyField) {
      this.message1 = 'Please enter all OTP digits.';
      this.loaderEnd();
      return;
    }

    // Now verify with server
    // const isValid = this.ServerService.verifyOtp(mobile, enteredOtp);
    this.ServerService.verifyOtp(mobile, enteredOtp).subscribe((response: any) => {
      if (response.data == 1 || response.data == '1') {
        this.message = 'Login successful!';
        this.otpModalVisible = false;
        localStorage.setItem('user_name', mobile);
        // localStorage.setItem('api_version', "2");
        // localStorage.setItem('client_id', "pmtgw1");
        // localStorage.setItem('ps_key', "3cd4_57b3_9d73_54BB");
        // localStorage.setItem('nas_id', "rlcalcare");
        // localStorage.setItem('user_id', "2");
        this.auth.login('dummy_token');
        this.idle.startWatching();
        this.log_details();
        this.router.navigate(['/users-dashboard']);
        this.loaderEnd();


      } else {
        this.message = 'Invalid OTP or OTP expired!';
        this.loaderEnd();
      }

    });




  }

  log_details() {
    const api_req: any = {
      action: "login",
      phone_number: this.loginForm.value.user_name

    };

    this.ServerService.sendzohoServer(api_req).subscribe((response: any) => {
      if (response.success == true || response.success == "true") {

      } else {

      }
    });
  }

  closeOtpModal() {
    this.loginButton = false;
    this.otpModalVisible = false;
  }





}
